import {
  Collapse,
  Navbar,
  NavbarToggler,
  Nav,
  NavItem,
} from 'reactstrap';
import React from 'react';
import Link from 'gatsby-link';
import logo from '../../images/frk_logo.png';

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: true,
      dropdownServicesOpen: false
    };
    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.toggleServicesDropdown = this.toggleServicesDropdown.bind(this);
    this.handleNavigation = this.handleNavigation.bind(this);
  }
  // Toggles navbar visibility.
  toggleNavbar() {
    const dropdownServicesOpen = this.state.dropdownServicesOpen;
    this.setState({
      collapsed: !this.state.collapsed,
      dropdownServicesOpen: !this.state.collapsed ? false : dropdownServicesOpen,
    });
  }
  // Toggles the dropdown display of menu item 'Services'.
  toggleServicesDropdown() {
    this.setState({
      dropdownServicesOpen: !this.state.dropdownServicesOpen,
    });
  }
  // Handles click on navigation item links.
  handleNavigation() {
    this.setState({
      collapsed: true,
      dropdownServicesOpen: false,
    });
  }

  render() {
    const dropdownServicesOpenClass = this.state.dropdownServicesOpen ? 'open' : 'closed';
    return (
      <header className="header">
        <div className="container--wide">
          <div className="row">
            <div className="col-md-4">
              <Link to="/"><img src={logo} alt="Logo" className="header__logo img-fluid" /></Link>
            </div>
            <div className="col-md-8 header__navigation">
              <Navbar dark expand="md">
                <NavbarToggler onClick={this.toggleNavbar} className="mr-3" />
                <Collapse isOpen={!this.state.collapsed} navbar>
                  <Nav navbar>
                    <NavItem><Link to="/kanzlei" onClick={this.handleNavigation}>Kanzlei</Link></NavItem>
                    <NavItem><Link to="/berater" onClick={this.handleNavigation}>Berater</Link></NavItem>
                    <NavItem>
                      <span className={`header__navigation__dropdown ${dropdownServicesOpenClass}`} onClick={this.toggleServicesDropdown}>
                        Leistungen
                      </span>
                      <ul className={dropdownServicesOpenClass}>
                        <li><Link to="/steuerberatung" onClick={this.handleNavigation}>Steuerberatung</Link></li>
                        <li><Link to="/betriebswirtschaftliche-beratung" onClick={this.handleNavigation}>Betriebswirtschaftliche
                          Beratung</Link></li>
                        <li><Link to="/dienstleistungen-in-kooperation" onClick={this.handleNavigation}>Dienstleistungen in
                          Kooperation</Link></li>
                        <li><Link to="/buchhaltung" onClick={this.handleNavigation}>Finanz- und Lohnbuchhaltung</Link></li>
                        <li><Link to="/unternehmensbewertung" onClick={this.handleNavigation}>Unternehmensbewertung</Link></li>
                      </ul>
                    </NavItem>
                    <NavItem><Link to="/karriere" onClick={this.handleNavigation}>Karriere</Link></NavItem>
                    <NavItem><Link to="/kontakt" onClick={this.handleNavigation}>Kontakt</Link></NavItem>
                  </Nav>
                </Collapse>
              </Navbar>
            </div>
          </div>
        </div>
      </header>
    );
  }
}
export default Header;



// WEBPACK FOOTER //
// ./src/components/header/index.js